export const UserRole = {
  USER: 'user',
  GYM_OWNER: 'gym_owner',
  TRAINER: 'trainer',
  ADMIN: 'admin',
};

export const isPhase2Enabled = () => {
  const raw = process.env.REACT_APP_ENABLE_PHASE2;
  if (raw === undefined) return true;
  return raw !== 'false' && raw !== '0';
};

export const pickLandingPath = (user) => {
  if (!user) return '/';

  // Approved vendors (role promoted by admin) land on their dashboards
  const role = user.role ?? UserRole.USER;
  if (role === UserRole.TRAINER) return '/trainer/dashboard';
  if (role === UserRole.GYM_OWNER) return '/gym/dashboard';
  if (role === UserRole.ADMIN) return '/admin/queue';

  // First-time users pick their intent before onboarding
  if (!user.role_intent) return '/welcome';

  // Vendor applicants (intent set but not yet approved) resume their flow
  if (user.role_intent === UserRole.GYM_OWNER) return '/apply/gym';
  if (user.role_intent === UserRole.TRAINER) return '/apply/trainer';

  // End-user flow
  if (!user.is_onboarded) return '/onboarding';
  if (!user.is_subscribed) return '/payment';
  return '/dashboard';
};
